import type { BlockExportMapping } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { CardCallToAction } from "./CardCallToAction";

export const callToActionBlocks: BlockExportMapping = {
  CardCallToAction,
};
